// サービス内容(表示用)
export const CHIIKITEICHAKU_DISPLAY_SERVICE_STATUS_LIST = [
  { label: "-", value: "0" },
  { label: "緊急時支援Ⅰ", value: "1" },
  { label: "緊急時支援Ⅱ", value: "2" }
];

export const CHIIKITEICHAKU_STATUS_LIST = {
  NONE: { label: "-", value: "0" },
  ONE: { label: "緊急時支援Ⅰ", value: "1" },
  TWO: { label: "緊急時支援Ⅱ", value: "2" }
};

export const CHIIKITEICHAKU_DISPLAY_STATUS_LIST = [
  CHIIKITEICHAKU_STATUS_LIST.NONE,
  CHIIKITEICHAKU_STATUS_LIST.ONE,
  CHIIKITEICHAKU_STATUS_LIST.TWO
];

export const DISPLAY_USER_SUMMARY_BUTTONS = [
  { label: "アセスメント", path: "#/record/support_plan/:uifId/assessment" },
  { label: "定着台帳", path: "#/record/support_plan/:uifId/support_ledger" },
  { label: "支援記録", path: "#/record/:uifId/support" }
];

export const CHIIKITEICHAKU_PLAN_LIST_TAB_PATH = {
  SUPPORT_LEDGER: "support_ledger"
} as const;

/** 地域定着台帳の関係機関先type */
export const RELATED_ORGANIZATION_TARGET_TYPE = {
  /** 福祉サービス */
  welfareService: 0,
  /** 医療機関 */
  medicalInstitution: 1,
  /** ライフライン */
  lifeline: 2,
  /** その他 */
  other: 3
} as const;
